import { render, staticRenderFns } from "./m-register.vue?vue&type=template&id=2ca68b9a&scoped=true&"
import script from "./m-register.vue?vue&type=script&lang=js&"
export * from "./m-register.vue?vue&type=script&lang=js&"
import style0 from "./m-register.vue?vue&type=style&index=0&id=2ca68b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca68b9a",
  null
  
)

export default component.exports